//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
import "../CAM/CAM.CustomLoops.js";
import "../no/SelectTaggedObjectList.js";
import "../no/ScCollector.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AngleToleranceEdges",1,0],[0,"BoundaryEdges",0,"ScCollector",0],[0,"CheckStock",1,0],[0,"CustomFeed",1,0],[0,"CustomPartOffset",1,0],[0,"CustomStock",1,0],[0,"CustomTolerance",1,0],[0,"DraftAngle",1,0],[0,"DriveStock",1,0],[0,"FeedUnit",1,0],[0,"FeedValue",1,0],[0,"FinalStock",1,0],[1,"HoleList",0,"CAM.CustomLoops",1],[0,"IgnoreLoopsStatus",1,1],[0,"InitialStock",1,0],[0,"Intol",1,0],[0,"MaterialSide",1,0],[0,"Outtol",1,0],[0,"PartOffset",1,0],[0,"Reversed",1,0],[0,"SafeClearance",1,0],[0,"ScCollector",0,"ScCollector",0],[0,"SeedFace",1,"Face",0],[1,"Selection",0,"SelectTaggedObjectList",0],[0,"TraverseInteriorEdges",1,0],[0,"UseTangentEdgeAngles",1,0]],[[[],"RemoveSelectionIntent",{},0,0],[[],"ApplyEdgeSelection",{},0,0],[["name","useDefaultName"],"SetName",{},2,0],[["itemCount"],"GetItems",{R_:{geometryItems:"TaggedObject[]"}},0,0]],[]];
SPLM.CAM.GeometrySet = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.GeometrySet";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.GeometrySet.LoopsIgnoreTypes = Object.freeze({
    "None" : "None", "All" : "All", "Specify" : "Specify"});

SPLM.CAM.GeometrySet.MaterialSideTypes = Object.freeze({
    "None" : "None", "Same" : "Same", "Opposite" : "Opposite"});

export default SPLM;